<script setup lang="ts">
import { t } from '@/i18n'
import { languages } from '@/i18n/config'
</script>

<template>
  <footer class="footer">
    <div class="container">
      <p><strong>{{ t.footerDescription }}</strong></p>
      <p class="footer-keywords">{{ t.footerKeywords }}</p>
      <nav class="footer-languages" aria-label="Languages">
        <a
          v-for="lang in Object.values(languages)"
          :key="lang.code"
          :href="lang.path ? lang.path + '/' : '/'"
          :hreflang="lang.code"
        >{{ lang.name }}</a>
      </nav>
      <p>
        {{ t.footerMadeWith }} <span class="heart-icon" aria-hidden="true">♥</span> {{ t.footerBy }}
        <a href="https://github.com/DarkDiamonD" target="_blank" rel="noopener noreferrer">DarkDiamonD</a>
      </p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: var(--footer-background);
  /* Increased opacity from 0.4 to 0.75 for WCAG AA contrast compliance (4.5:1 ratio) */
  color: rgba(255, 255, 255, 0.75);
  border-top: 1px solid var(--border-color);
  padding: 2rem 0;
  text-align: center;
  margin-top: auto;
}

.footer p {
  margin: 0.5rem 0;
  font-size: 0.875rem;
}

.footer .footer-keywords {
  /* Increased opacity from 0.3 to 0.6 for better contrast */
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
  font-style: italic;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.footer-languages {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  margin: 0.75rem 0;
  font-size: 0.8125rem;
}

.footer a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.5);
  text-underline-offset: 2px;
  transition: color var(--transition-normal), text-decoration-color var(--transition-normal);
}

.footer a:hover {
  color: rgba(255, 255, 255, 1);
  text-decoration-color: rgba(255, 255, 255, 1);
}

.footer .heart-icon {
  color: var(--heart-color);
  display: inline-block;
  animation: heartbeat 1.5s ease-in-out infinite;
}

@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  10%, 30% {
    transform: scale(1.1);
  }
  20%, 40% {
    transform: scale(1);
  }
}
</style>
